import { Component } from "react";
import Box from '@mui/material/Box';
import UnitTypes from "../../../models/UnitTypes";
import UnitTypesSelect from "./UnitTypeSelect";
import UnitMasonry from "./unitMasonry";
import UnitTypesApi from "../../../api/UnitTypesApi";
import { Link } from "@mui/material";

type Props = {};

type State = {
  unitTypes: any[],
  catalog: any[],
  expanded: Set<number>
}

export default class UnitsCatalog extends Component<Props, State> {

  page: number = 0
  size: number = 20

  stateReplacer: {
    unitTypes: any[],
    catalog: any[],
    expanded: Set<number>
  } = {
    unitTypes: [],
    catalog: [],
    expanded: new Set<number>()
  }

  constructor(props: Props) {
    super(props)
    this.state = {
      unitTypes: UnitTypes.map(unitType => { return  {unitType, selected: false}}),
      catalog: [],
      expanded: new Set<number>()
    }
  }

  componentDidMount() {
    UnitTypesApi.filter(this.page, this.size).then((it: any) => this.setCatalog(it.data))
  }

  invertSelected(index: number) {
    let unitTypes = this.state.unitTypes.map((it, iIndex) => {
      return  {
        unitType: it.unitType,
        selected: index === iIndex ? !it.selected : it.selected
      }
    })

    this.setState({
      unitTypes,
      catalog: this.state.catalog,
      expanded: this.state.expanded
    })

    // this.setState({
    //   unitTypes,
    //   catalog: this.state.catalog,
    //   expanded: this.state.expanded
    // })
    this.stateReplacer.unitTypes = unitTypes
    this.updateCatalog(unitTypes)
  }

  updateCatalog(unitTypes: any[]) {
    let unitTypeKeys = unitTypes
    .filter(it => it.selected)
    .map(it => it.unitType)
    this.page = 0
    UnitTypesApi.filter(this.page, this.size, unitTypeKeys).then((it: any) => {
      this.stateReplacer.catalog = it.data
      this.stateReplacer.expanded = new Set<number>()
      this.setState(this.stateReplacer)
    })
  }

  addToCatalog() {
    let unitTypeKeys = this.state.unitTypes
    .filter(it => it.selected)
    .map(it => it.unitType)
    this.page += 1
    UnitTypesApi.filter(this.page, this.size, unitTypeKeys).then((it: any) => this.setCatalog(this.state.catalog.concat(it.data)))
  }

  setCatalog(catalog: any[]) {
    this.setState({
      unitTypes: this.state.unitTypes,
      catalog,
      expanded: this.state.expanded
    })
  }

  setExpanded(expanded: Set<number>) {
    this.setState({
      unitTypes: this.state.unitTypes,
      catalog: this.state.catalog,
      expanded: expanded
    })
  }

  handleExpanded(index: number) {
    let newExpanded = this.state.expanded;
    newExpanded.has(index) ? newExpanded.delete(index) : newExpanded.add(index)
    this.setState({expanded: newExpanded})
  }

  render() {
    return (
      <Box>
        <UnitTypesSelect unitTypes={this.state.unitTypes} invertSelected={this.invertSelected.bind(this)}></UnitTypesSelect>
        <UnitMasonry catalog={this.state.catalog} addToCatalog={this.addToCatalog.bind(this)} expanded={this.state.expanded} handleExpanded={this.handleExpanded.bind(this)}></UnitMasonry>
        <Box display="flex" justifyContent="center" mt={2} mb={6}>
          <Link href="https://www.olca.com.ar/#contact" target="_blank" rel="noreferrer"
                className="btn-primary-link">Solicitar cotización</Link>
        </Box>
      </Box>
    );
  }
}
